import { useCallback, useState } from 'react'

function useConfirmationDialog(handleConfirm) {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleConfirmConfirmationDialog = useCallback(
    async (...args) => {
      setLoading(true)
      const result = await handleConfirm(...args)
      if (typeof result === 'boolean' && result === false) {
        setLoading(false)
        return
      }
      setOpenConfirmationDialog(false)
      setLoading(false)
    },
    [handleConfirm]
  )

  const handleOpenConfirmationDialog = () => {
    setOpenConfirmationDialog(true)
  }

  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false)
  }

  return {
    loading,
    openConfirmationDialog,
    handleConfirmConfirmationDialog,
    handleOpenConfirmationDialog,
    handleCloseConfirmationDialog,
  }
}

export default useConfirmationDialog
